@if (isBrowser) {
<div class="no-data">
  <nz-empty [nzNotFoundContent]="'NoDataFound' | translate"></nz-empty>
</div>
}